export default __webpack_public_path__ + "static/media/singularity2045-colored.60106840.webp";